import * as Types from '../../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type EditProjectRequestMutationVariables = Types.Exact<{
  input: Types.EditProjectRequestCommand;
}>;


export type EditProjectRequestMutation = { __typename?: 'MutationModel', projectRequests: { __typename?: 'ProjectRequestMutationModel', edit: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const EditProjectRequestDocument = gql`
    mutation EditProjectRequest($input: EditProjectRequestCommand!) {
  projectRequests {
    edit(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type EditProjectRequestMutationFn = Apollo.MutationFunction<EditProjectRequestMutation, EditProjectRequestMutationVariables>;

/**
 * __useEditProjectRequestMutation__
 *
 * To run a mutation, you first call `useEditProjectRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectRequestMutation, { data, loading, error }] = useEditProjectRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectRequestMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectRequestMutation, EditProjectRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectRequestMutation, EditProjectRequestMutationVariables>(EditProjectRequestDocument, options);
      }
export type EditProjectRequestMutationHookResult = ReturnType<typeof useEditProjectRequestMutation>;
export type EditProjectRequestMutationResult = Apollo.MutationResult<EditProjectRequestMutation>;
export type EditProjectRequestMutationOptions = Apollo.BaseMutationOptions<EditProjectRequestMutation, EditProjectRequestMutationVariables>;